export default __webpack_public_path__ + "static/image01-3d6ee963ac59008a1483baa2718e8fa9.png";